export default {
	container: "Container",
	droppedContainer: "DroppedContainer",
	coin: "budget",
	time: "time"
}
